import {
  setContext as SentrySetContext,
  setTag as SentrySetTag,
  addBreadcrumb as SentryAddBreadcrumb,
  captureMessage as SentryCaptureMessage,
  captureException as SentryCaptureException
} from "@sentry/nextjs";

export const Levels = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  DEBUG: 'debug'
};

export class Logger {

  static page = "unknown";

  static setContext(identifier, context) {

    if (typeof identifier !== "string" || typeof context !== "object") {
      return;
    }

    Logger.page = context.page || "unknown";

    SentrySetContext(identifier, context);
  }

  static setTags(tags) {

    if (typeof tags !== "object") {
      return;
    }

    for (const [key, val] of Object.entries(tags)) {

      if (!key || !val) {
        continue;
      }

      SentrySetTag(key, val);
    }
  }

  static breadcrumb(
    message,
    category,
    type,
    data,
    level = Levels.INFO
  ) {

    if (!message) {
      return;
    }

    SentryAddBreadcrumb({
      message,
      level,
      category,
      type,
      data,
      timestamp: Date.now()
    });
  }

  static info(
    message,
    component,
    context = {},
    tags = {}
  ) {

    if (!message) {
      return;
    }

    SentryCaptureMessage(message, {
        contexts: {
          "Additional Context": {
            ...context,
            Component: component,
          }
        },
        tags: {
          ...tags,
          component: component,
          page: Logger.page,
        }
      }
    );
  }

  static error(
    error,
    component,
    context = {},
    tags = {}
  ) {

    try {

      const isErrorInstance = error instanceof Error;

      if (!isErrorInstance && typeof error === "object") {
        error = Error(JSON.stringify(error));
      }

      if (!isErrorInstance && typeof error === "string") {
        error = Error(error);
      }

      if (!(error instanceof Error)) {
        // unsupported error type
        return;
      }

      SentryCaptureException(error, {
        contexts: {
          "Additional Context": {
            ...context,
            Component: component,
          }
        },
        tags: {
          ...tags,
          component: component,
          page: Logger.page,
        }
      });
    }
    catch(e) {
      SentryCaptureException(Error("Unable to log sentry exception"));
    }
  }
}